"use client";

import styled from "styled-components";

export const CardService = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.4s;

  &:hover {
    box-shadow: var(--shadowHoverCard);
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-wrap: nowrap;
`;

export const BoxIcon = styled.div`
  background: var(--softMint);
  border-radius: 5px;
  padding: 5px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--greenAndWhite);
    }
    circle {
      stroke: var(--greenAndWhite);
    }
  }
`;

export const TitleCard = styled.h3`
  font-family: "Inter Medium";
  font-size: 16px;
  color: var(--colorTitle);
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
`;

export const FooterCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
`;

export const Value = styled.span`
  font-family: "Inter Medium";
  font-size: 18px;
`;

export const Time = styled.span`
  display: block;
  font-family: "Inter Regular";
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 50px;
  background: var(--backgroundColor);
`;
